import DataVTitleBar from './title-bar';
export default DataVTitleBar;
